import { User, Car, Gauge } from 'lucide-react';

interface CustomerDataSectionProps {
  customerName: string;
  vehicleMileage: number;
  modelName?: string;
  versionName?: string;
}

export function CustomerDataSection({
  customerName,
  vehicleMileage,
  modelName,
  versionName,
}: CustomerDataSectionProps) {
  return (
    <>
      <div className="border-t pt-4">
        <h4 className="font-medium mb-3">Dados do Cliente</h4>

        <div className="space-y-3">
          <div className="flex items-start gap-3">
            <User className="size-5 text-gray-500 mt-0.5" />
            <div>
              <p className="font-medium text-sm">Nome</p>
              <p className="text-sm text-gray-600">{customerName}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t pt-4">
        <h4 className="font-medium mb-3">Dados do Veículo</h4>

        <div className="space-y-3">
          {(modelName || versionName) && (
            <div className="flex items-start gap-3">
              <Car className="size-5 text-gray-500 mt-0.5" />
              <div>
                <p className="font-medium text-sm">Modelo / Versão</p>
                <p className="text-sm text-gray-600">{modelName || '-'} - {versionName || '-'}</p>
              </div>
            </div>
          )}

          <div className="flex items-start gap-3">
            <Gauge className="size-5 text-gray-500 mt-0.5" />
            <div>
              <p className="font-medium text-sm">Quilometragem</p>
              <p className="text-sm text-gray-600">{vehicleMileage?.toLocaleString('pt-BR')} km</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
